import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import imagen1 from '../img/get_view1.jpg'; 
import { GrupoContext } from '../GrupoContext';
import Sidebar from '../componenteExtra/SidebarStaff';
import NotificationBellStaff from '../notificaciones/NotificationBellStaff'; // Asegúrate de ajustar la ruta
import { FaTasks, FaClipboardList } from 'react-icons/fa';
import Footer from '../componenteExtra/Footer';
import SessionManager from '../componenteExtra/SessionManager';

const Rol = () => {
  const navigate = useNavigate();
  const { grupo, setGrupo } = useContext(GrupoContext);
  const [nombreGet, setNombreGet] = useState('');

  useEffect(() => {
    // Restaurar el estado del nombre desde localStorage
    const savedNombreGet = localStorage.getItem('nombre_get');
    if (savedNombreGet) {
      setNombreGet(savedNombreGet);
    }
  }, []);

  useEffect(() => {
    // Guardar el nombre en localStorage si cambia
    if (nombreGet) {
      localStorage.setItem('nombre_get', nombreGet);
    }
  }, [nombreGet]);

  return (
    <div className="app">
      <SessionManager />
      <div className="main-content">
        <Sidebar />
        <div className="main-panel">
          <div className="welcome-message">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "20px 0",
                width: "100%",
                marginBottom: "10px",
              }}
            >
              <h2 style={{ margin: 0, lineHeight: 1 }}>
                Bienvenido(a) Staff {nombreGet}
              </h2>
              {nombreGet && <NotificationBellStaff />}
            </div>
            <img src={imagen1} alt="Decorative" style={{ width: '100%', height: 'auto' }} />
          </div>
          <div className="cards-container">
            <div className="card">
              <div className="card-header">
                <FaTasks />
                <h3>Mis asignaciones</h3>
              </div>
              <div className="card-subtitle">Acceso Directo</div>
              <div className="card-content">
                En este módulo encontrarás las actividades que se te asignaron.
              </div>
              <button onClick={() => navigate('/MisAsignaciones')}>Ir a Mis Asignaciones</button>
            </div>
            <div className="card">
              <div className="card-header">
                <FaClipboardList />
                <h3>Asignaciones en revisión</h3>
              </div>
              <div className="card-subtitle">Acceso Directo</div>
              <div className="card-content">
                En este módulo estarán las actividades que serán aprobadas o rechazadas.
              </div>
              <button onClick={() => navigate('/AsignacionesEnRevision')}>Ir a Asignaciones en Revisión</button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Rol;